// extracted by mini-css-extract-plugin
export default {"navbarSubItem":"NavbarSubItem_navbarSubItem__OgBK9","label":"NavbarSubItem_label__hEgNA","activeItem":"NavbarSubItem_activeItem__eVRX9"};